// Email Template Edit
export * from "./emailTemplateEdit.component";
export * from "../emailTemplates.service";


// WEBPACK FOOTER //
// ./src/app/modules/userHome/emailTemplates/emailTemplateEdit/index.ts